var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "scale(1 -1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.364433 7.05701C0.857006 7.54958 1.6531 7.54958 2.13337 7.05701L6 3.19037L9.86664 7.05701C10.3592 7.54958 11.1553 7.54958 11.6356 7.05701C12.1281 6.56444 12.1281 5.7806 11.6356 5.28807L6.88447 0.536972C6.6446 0.297104 6.32872 0.170752 6 0.170752C5.67129 0.170752 5.34307 0.297104 5.11554 0.536972L0.364433 5.28807C-0.128139 5.78065 -0.128139 6.56398 0.364433 7.05701Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.36355975419fadf3085dbf7bf6a7c77d.svg";
export { ForwardRef as ReactComponent };